<template>
  <div class="edu-info-wrap">
    <div class="middle-edu"
      v-for="(item, index) in achievementList"
         :key="index"
    >
      <div class="title" style="width: 30px">{{ index + 1 }}</div>
      <div class="detail-wrap">
        <div class="item" style="width: 331px; flex: none; margin-left: 0;">
          <el-input v-model="item.awardingBody" placeholder="Name of association/ awarding body"></el-input>
        </div>
        <div class="item" style="width: 331px; flex: none">
          <el-date-picker
            v-model="item.achievementDate"
            format="yyyy"
            value-format="yyyy"
            type="year"
            placeholder="Achievement Date"></el-date-picker>
        </div>
        <div class="item">
          <el-input v-model="item.awarded" placeholder="Awarded"></el-input>
        </div>
        <span class="delete" v-if="index > 0" @click="handleDeleteItem(index)">delete</span>
      </div>
    </div>
    <div v-show="clickCounter <= 2" class="bottom-btn">
      <el-button @click="addClickCounter" style="display:block;margin: 0 auto;width: 120px;color: #007ab0;" type="text" icon="el-icon-plus">Add Achievement</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      achievementList: [{
        awardingBody: '',
        achievementDate: '',
        awarded: '',
      }],
      clickCounter: 0
    }
  },
  mounted() {
  },
  methods: {
    addClickCounter() {
      this.clickCounter += 1
      this.achievementList.push({
        awardingBody: '',
        achievementDate: '',
        awarded: '',
      })
    },
    handleDeleteItem(index) {
      this.clickCounter -= 1
      this.$delete(this.achievementList, index)
    }
  }
}
</script>

<style lang="stylus">
  .edu-info-wrap
    margin-top 24px
    .high-edu, .middle-edu, .low-edu, .highest-edu
      position relative
      display flex
      margin-bottom 24px
      .delete
        position absolute
        top 8px
        right -50px
        font-size 14px
        color #f03b3b
        cursor pointer
      .title
        width 30px
        line-height 40px
        font-size 14px
        font-weight bold
        color #333
      .detail-wrap
        flex 1
        display flex
        .item
          position relative
          flex 1
          margin-left 24px
          .zoom-search-menu
            overflow scroll
            position absolute
            top 44px
            left 0
            width 100%
            max-height 200px
            z-index 1001
            //border 1px solid #e4e7ed
            border-radius 4px
            background-color #ffffff
            box-shadow 0 2px 12px 0 rgba(0,0,0,.1)
            box-sizing border-box
            margin 5px 0
            .zoom-search-menu-item
              display flex
              font-size 12px
              padding 0 20px
              position relative
              white-space nowrap
              overflow hidden
              text-overflow ellipsis
              color #606266
              height 34px
              line-height 34px
              cursor pointer
              overflow hidden
              box-sizing border-box
              .province
                width 50px
                flex 0 0 50px
                max-width 50px
                min-width 50px
              .name
                flex 1
                white-space nowrap
                overflow hidden
                text-overflow ellipsis
              &:hover
                background-color #f5f7fa
              &.hover
                background-color #f5f7fa
            &.slide-fade-enter-active
              transition all .3s ease
            &.slide-fade-leave-active
              transition all .3s ease
            &.slide-fade-enter, .slide-fade-leave-to
              transform translateX(10px)
              opacity 0
          .el-input
            width 100%
</style>



// WEBPACK FOOTER //
// src/components/achievement/index.vue